<template>
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    top="5vh"
    width="970px"
  >
    <div class="main-container">
      <img class="background-img" src="@/assets/pics/my_license.png" alt="" />
      <div class="content-container">
        <div class="top-title">{{ languages.myLicense }}</div>
        <el-table
          :data="userLicenses"
          :header-cell-style="{ background: '#f0f6ff', textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          size="mini"
          height="340px"
          border
          stripe
        >
          <el-table-column :label="languages.name" width="206px" prop="softwareName">
            <template slot-scope="scope">
              {{ scope.row.softwareId === 283 ? languages.allApp : scope.row.softwareName }}
            </template>
          </el-table-column>
          <el-table-column :label="languages.type" width="85px" prop="assign">
            <template slot-scope="scope">
              {{ languages[scope.row.assign] }}
            </template>
          </el-table-column>
          <el-table-column :label="languages.status" width="80px" prop="keyStatus">
            <template slot-scope="scope">
              <div :class="scope.row.keyStatus === 'using' ? 'using-color' : 'exp-color'">
                {{ languages[scope.row.keyStatus] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="languages.applyDate" width="140px" prop="applyTime">
          </el-table-column>
          <el-table-column :label="languages.expDate" width="140px" prop="userAuthExpireTime">
          </el-table-column>
          <el-table-column :label="languages.remain" width="86px" prop="leftDays">
            <template slot-scope="scope">
              {{ showDays(scope.row.leftDays, scope.row.assign) }}
            </template>
          </el-table-column>
          <el-table-column :label="languages.operate" width="86px" prop="">
            <template slot-scope="scope">
              <div
                class="recycle-button"
                v-if="scope.row.keyStatus === 'using'"
                @click="handleReturn(scope.row)"
              >
                {{ languages.recycle }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="languages.rate" width="86px" prop="">
            <template slot-scope="scope">
              <div class="rated-button" v-if="scope.row.appraise">
                {{ languages.rated }}
              </div>
              <div
                class="rate-button"
                v-else-if="scope.row.keyStatus === 'using'"
                @click="handleVote(scope.row)"
              >
                {{ languages.rate }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="recycle-tips">{{ languages.recycleTips }}</div>
        <div class="close-button" @click="homeTemplate.showMyLicenseDialog = false">
          {{ languages.close }}
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showAdobeAllDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
      width="460px"
      top="8vh"
    >
      <div class="adobe-container">
        <div class="adobe-title">{{ languages.adobeTitle }}</div>
        <div class="adobe-tip">{{ languages.adobeTips1 }}</div>
        <div class="adobe-tip2">{{ languages.adobeTips2 }}</div>
        <div class="list-title">
          <div class="title-check">{{ languages.recycle }}</div>
          <div class="title-name">{{ languages.softName }}</div>
        </div>
        <div class="adobe-list">
          <div
            class="single-license"
            :style="index === licenseSoftList.length - 1 ? 'border-bottom:0px' : ''"
            :class="index % 2 === 0 ? 'strip-background' : ''"
            v-for="(soft, index) in checkList"
            :key="soft.id"
          >
            <template v-if="soft">
              <div class="license-check" @click="handleCheck(soft.id)">
                <img
                  :src="require(`assets/pics/licence/${soft.check ? 'check' : 'uncheck'}.png`)"
                  alt=""
                  srcset=""
                />
              </div>
              <div class="license-name" @click="handleCheck(soft.id)">{{ soft.name }}</div>
            </template>
          </div>
        </div>
      </div>
      <div class="check-all" @click="handleCheckAll()">
        <img
          :src="require(`assets/pics/licence/${checkAll ? 'check' : 'uncheck'}.png`)"
          alt=""
          srcset=""
        />{{ checkAll ? languages.uncheckAll : languages.checkAll }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-cancel" :disabled="isRecycling" @click="handleCancel()">
          {{ languages.cancel }}
        </el-button>
        <el-button
          class="btn-confirm"
          type="primary"
          :loading="isRecycling"
          :class="noRecycle ? 'disable-button' : ''"
          :disabled="noRecycle"
          @click="handleRecyle('Adobe')"
        >
          {{ languages.confirm }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="showConfirmDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
      width="350px"
      top="30vh"
    >
      <div class="confirm-container">
        <div class="confirm-title">{{ languages.earlyReturn }}</div>
        <div>{{ languages.tip1.replace('%TYPE%', languages[confirmSoft.assign]) }}</div>
        <div class="confirm-name">【{{ confirmSoft.softwareName }}】</div>
        <div>{{ languages.tip2 }}</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="btn-cancel" :disabled="isRecycling" @click="handleCancel()">
          {{ languages.cancel }}
        </el-button>
        <el-button
          class="btn-confirm"
          type="primary"
          :loading="isRecycling"
          @click="handleRecyle('Single')"
        >
          {{ languages.confirm }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="showVoteDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
      width="450px"
      top="30vh"
    >
      <div class="confirm-container">
        <div class="vote-title">{{ languages.rateTip }}:</div>
        <div class="vote-content">
          <img
            v-for="index in 5"
            :key="index"
            @click="voteStar(index)"
            :src="require(`@/assets/pics/star_${level >= index ? 'on' : 'off'}.png`)"
            alt=""
          />
        </div>
        <div class="vote-input">
          <el-input
            size="small"
            type="textarea"
            :rows="4"
            :placeholder="languages.inputTip"
            v-model="voteInput"
          ></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="btn-cancel" :disabled="isRecycling" @click="handleCancel()">
          {{ languages.cancel }}
        </el-button>
        <el-button
          class="btn-confirm"
          :type="level === 0 ? 'info' : 'primary'"
          :disabled="level === 0"
          @click="submitVote()"
        >
          {{ languages.rate }}
        </el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ubtSendTrace } from '../../utils/ubt';

export default {
  inject: ['homeTemplate'],
  data() {
    return {
      showConfirmDialog: false,
      showAdobeAllDialog: false,
      showVoteDialog: false,
      confirmSoft: '',
      voteInput: '',
      isRecycling: false,
      checkList: [],
      softwareIdList: [],
      checkAll: false,
      allCheckCount: 0,
      level: 0,
    };
  },
  computed: {
    ...mapState(['userLicenses', 'licenseSoftList', 'pvId']),
    noRecycle() {
      return this.checkList.length - this.allCheckCount >= 3;
    },
  },
  watch: {
    show(val) {
      if (val) {
        ubtSendTrace(
          245278,
          'sw_install',
          'click',
          'permissions',
          '',
          '',
          this.pvId,
        );
        this.allCheckCount = 0;
        this.getUserLicense();
        this.checkAll = false;
      }
    },
  },
  props: {
    show: Boolean,
    languages: Object,
    lan: String,
  },
  methods: {
    ...mapActions(['getUserLicense', 'recycleLicense', 'saveLog']),
    handleCancel() {
      this.confirmSoft = '';
      this.voteInput = '';
      this.isRecycling = false;
      this.showConfirmDialog = false;
      this.showAdobeAllDialog = false;
      this.showVoteDialog = false;
      this.checkAll = false;
      this.checkList = [];
      this.softwareIdList = [];
      this.level = 0;
    },
    handleCheck(id) {
      this.allCheckCount = 0;
      this.checkList.forEach((el) => {
        const soft = el;
        if (soft.id === id) soft.check = !soft.check;
        if (soft.check) this.allCheckCount += 1;
      });
      this.checkAll = this.allCheckCount === this.checkList.length;
      this.$forceUpdate();
    },
    handleCheckAll() {
      this.checkAll = !this.checkAll;
      this.allCheckCount = this.checkAll ? this.checkList.length : 0;
      this.checkList.map((el) => {
        const soft = el;
        soft.check = this.checkAll;
        return soft;
      });
    },
    handleReturn(scope) {
      this.confirmSoft = scope;
      this.saveLog({
        title: 'HandleRecycle Open',
        target: 'handleReturn',
        description: 'User Open Software Recycle Dialog',
        softwareName: this.confirmSoft.softwareName,
        softwareId: this.confirmSoft.id,
      });
      if (scope.softwareId === 283) {
        this.showAdobeAllDialog = true;
        this.checkList = this.licenseSoftList.map((el) => {
          const soft = el;
          soft.check = false;
          return soft;
        });
      } else {
        this.showConfirmDialog = true;
      }
    },
    voteStar(number) {
      this.level = number;
    },
    handleVote(scope) {
      this.saveLog({
        title: 'LicenseVoteOpen',
        target: 'handle Vote',
        description: 'User Open License Vote Dialog',
        softwareName: this.confirmSoft.softwareName,
        softwareId: this.confirmSoft.id,
      });
      this.confirmSoft = scope;
      this.showVoteDialog = true;
    },
    async submitVote() {
      await this.saveLog({
        title: 'License_Vote',
        target: 'iDesk Windows',
        description: 'User Submit License Vote',
        softwareName: this.confirmSoft.softwareName,
        softwareId: this.confirmSoft.id,
        reserve1: this.level,
        reserve2: this.voteInput,
      });
      this.handleCancel();
      this.getUserLicense();
    },
    async handleRecyle(type) {
      if (type === 'Adobe') {
        this.checkList.forEach((soft) => {
          if (!soft.check) this.softwareIdList.push(soft.id);
        });
      }
      this.isRecycling = true;
      const postData =
        type === 'Adobe'
          ? { licenseId: this.confirmSoft.id, softwareIdList: this.softwareIdList }
          : { licenseId: this.confirmSoft.id };
      const res = await this.recycleLicense(postData);
      if (res.code !== 1) {
        this.$message.warning({ message: res.msg, duration: 5000 });
        this.saveLog({
          title: 'HandleRecycle Failed',
          target: 'handleRecyle',
          description: 'User Submit Software Recycle',
          softwareName: this.confirmSoft.softwareName,
          softwareId: this.confirmSoft.id,
          reserve1: res.msg,
        });
      } else {
        this.saveLog({
          title: 'HandleRecycle Success',
          target: 'handleRecyle',
          description: 'User Submit Software Recycle',
          softwareName: this.confirmSoft.softwareName,
          softwareId: this.confirmSoft.id,
        });
      }
      this.handleCancel();
      this.getUserLicense();
    },
    showDays(days, type) {
      if (days && days > 0) {
        if (type === 'long') return '∞';
        return this.lan === 'cn' ? days : `${days}Days`;
      }
      return '-';
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  img {
    position: absolute;
    left: -15px;
    top: -15px;
    width: 1000px;
  }
  .content-container {
    position: absolute;
    top: 0px;
    width: 970px;
    height: 610px;
    z-index: 1;
    .top-title {
      color: #1466de;
      text-align: center;
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      margin-top: 20px;
    }
    .el-table {
      position: absolute;
      top: 120px;
      width: 910px;
      left: 30px;
      color: #999;
      font-family: PingFangSC-Regular;
      font-size: 12px;
    }
    .recycle-tips {
      position: absolute;
      text-align: center;
      left: 0;
      width: 970px;
      bottom: 123px;
      font-size: 12px;
      color: #f34500;
    }
    .close-button {
      text-align: center;
      position: absolute;
      left: 425px;
      bottom: 30px;
      background: #dce9fc;
      border-radius: 4px;
      height: 35px;
      width: 120px;
      color: #0080ff;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      line-height: 35px;
      box-shadow: 0 0 5px #666;
    }
  }
  .using-color {
    color: #01b87a;
  }
  .exp-color {
    color: #f34500;
  }
  .rate-button,
  .rated-button,
  .recycle-button {
    width: 60px;
    border-radius: 5px;
    color: #fff;
    background: #1466de;
    cursor: pointer;
  }
  .rate-button {
    background: #e6a23c;
  }
  .rated-button {
    background: #999;
    cursor: not-allowed;
  }
}
.confirm-container {
  text-align: center;
  color: #666;
  .confirm-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .confirm-name {
    margin: 5px 0;
    font-size: 16px;
    color: #1466de;
    font-weight: 600;
  }
  .vote-title {
    text-align: left;
    margin: 0 20px;
    font-size: 16px;
  }
  .vote-content {
    padding-top: 10px;
    img {
      width: 40px;
      margin: 0 10px;
      cursor: pointer;
    }
  }
  .vote-input {
    margin: 10px 20px 0 20px;
  }
}
.adobe-container {
  text-align: center;
  color: #666;
  .adobe-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #1466de;
  }
  .adobe-tip,
  .adobe-tip2 {
    margin: 0 20px;
    text-align: left;
    font-size: 12px;
    white-space: pre-wrap;
  }
  .adobe-tip2 {
    color: #f34500;
  }
  .list-title {
    display: flex;
    margin: 10px 20px 5px 20px;
    font-weight: 600;
    line-height: 25px;
    img {
      height: 16px;
      cursor: pointer;
    }
    .title-check {
      width: 150px;
    }
    .title-name {
      width: 100%;
    }
  }
  .adobe-list {
    border-radius: 5px;
    box-shadow: 0 0 5px #ccc;
    overflow-y: auto;
    height: 313px;
    margin: -1px 20px 10px 20px;
    .single-license {
      display: flex;
      font-size: 14px;
      line-height: 25px;
      border-bottom: 1px solid #ebeef5;
      cursor: pointer;
      .license-check {
        width: 150px;
        img {
          width: 16px;
          cursor: pointer;
          margin-bottom: -3px;
        }
      }
      .license-name {
        width: 100%;
        color: #1466de;
      }
    }
    .strip-background {
      background: #fafafa;
    }
  }
}
.btn-confirm,
.btn-cancel {
  width: 100px;
}
.check-all {
  position: absolute;
  cursor: pointer;
  width: 122px;
  left: 20px;
  img {
    height: 20px;
    margin: 0 10px -4px 10px;
  }
}
.disable-button {
  background: #999 !important;
  border: none;
}
</style>
<style>
::-webkit-scrollbar {
  width: 15px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  border: 4px solid rgba(0, 0, 0, 0);
  box-shadow: 8px 0 0 #cccccc inset;
}
::-webkit-scrollbar-thumb:hover {
  box-shadow: 8px 0 0 #a5adb7 inset;
}
</style>
